import { isUndefined, has, isNull, kebabCase } from 'lodash';
import React, { Component } from 'react';
import './BankSelect.scss';
import BankStatus from '../BankStatus/BankStatus';
import If from '../../Shared/If/If';
import RadioButton from '../../Shared/RadioButton/RadioButton';
import {
  isAppBuy,
  isAppSell,
  isBuy,
  isCollegeContribute,
  isCollegeDistribute,
  isRecurringBuy,
  isRecurringBuyEdit,
  isIRAAutoMax,
  isSell,
  isAutomaticSell,
} from '../../../utils/transactions-util';
import { hasValue, isJustAdded } from '../../../utils/utils';
import { isTransactionRestrictedForFundingBank } from '../../../utils/funds/shared/shared-fund-notes-utility';
import {
  BANK_STATUS,
  DELIVERY_EXPRESS_DELIVERY,
} from '../../../settings/settings';

export class BankSelect extends Component {
  constructor(props) {
    super(props);
    this.isDisabled = this.isDisabled.bind(this);
    this.bankAccountNumber = this.bankAccountNumber.bind(this);
    this.bankAccountType = this.bankAccountType.bind(this);
    this.bankName = this.bankName.bind(this);
  }

  isDisabled = (bank) => {
    const { automaticEditFund, agreementMap } = this.props;
    if (isUndefined(bank) || isNull(bank)) {
      return true;
    }
    const {
      bankAwaitingVerification,
      corruptBankData,
      hasRedemptionHold,
      externallyVerifiedBank,
      name,
    } = bank;

    if (
      bank.deliveryMethod &&
      bank.deliveryMethod === DELIVERY_EXPRESS_DELIVERY &&
      name.toUpperCase().includes('CHASE')
    ) {
      return true;
    }
    if (bank.bankStatus === BANK_STATUS.REQUIRES_UPDATE_955) {
      return true;
    }
    if (corruptBankData) {
      return corruptBankData;
    }
    if (
      isRecurringBuyEdit() &&
      automaticEditFund &&
      agreementMap[bank.bankAgreementID]
    ) {
      return (
        isTransactionRestrictedForFundingBank(
          automaticEditFund[0],
          agreementMap[bank.bankAgreementID]
        ) ||
        agreementMap[bank.bankAgreementID].associableAgreements.some(
          (itm) => automaticEditFund[0].uniqueKey === itm
        ) ||
        (isJustAdded(bank) && !externallyVerifiedBank) ||
        (isJustAdded(bank) !== true && bankAwaitingVerification)
      );
    }

    if (isBuy() || isCollegeContribute()) {
      return isJustAdded(bank) !== true && bankAwaitingVerification;
    }
    if (isRecurringBuy() || isIRAAutoMax() || isAppBuy()) {
      return (
        (isJustAdded(bank) && !externallyVerifiedBank) ||
        (isJustAdded(bank) !== true && bankAwaitingVerification)
      );
    }
    if (isSell() || isCollegeDistribute() || isAutomaticSell() || isAppSell()) {
      return hasRedemptionHold || bankAwaitingVerification;
    }
    return false;
  };

  bankName = (bank) => {
    if (isUndefined(bank) || isNull(bank)) {
      return '';
    }
    if (has(bank, 'name')) {
      return bank.name;
    }
    if (has(bank, 'bankName')) {
      return bank.bankName;
    }
  };

  bankAccountType = (bank, separator) => {
    if (isUndefined(bank) || isNull(bank)) {
      return '';
    }
    if (has(bank, 'bankAccountType')) {
      if (typeof separator === 'string' && separator.toUpperCase() === 'DASH') {
        return ' - ' + bank.bankAccountType;
      }
      return bank.bankAccountType;
    }
  };

  bankAccountNumber = (bank) => {
    if (isUndefined(bank) || isNull(bank)) {
      return '';
    }
    if (has(bank, 'accountNumber')) {
      return bank.accountNumber;
    }
  };

  render() {
    const {
      automaticEditFund,
      agreementMap,
      bank,
      className,
      bankIndex,
      numberOfBanks,
      onBankClick,
      selectedBank,
    } = this.props;
    if (
      bank.deliveryMethod &&
      bank.deliveryMethod === DELIVERY_EXPRESS_DELIVERY &&
      bank.name.toUpperCase().includes('CHASE')
    ) {
      bank.bankStatus = BANK_STATUS.CHASE_BANK;
    }
    const bankNotAssociableEdit =
      automaticEditFund &&
      isRecurringBuyEdit() &&
      agreementMap[bank.bankAgreementID]
        ? isTransactionRestrictedForFundingBank(
            automaticEditFund[0],
            agreementMap[bank.bankAgreementID]
          )
        : false;
    const bankNotAssociatedEdit =
      automaticEditFund &&
      isRecurringBuyEdit() &&
      agreementMap[bank.bankAgreementID]
        ? !isTransactionRestrictedForFundingBank(
            automaticEditFund[0],
            agreementMap[bank.bankAgreementID]
          ) &&
          agreementMap[bank.bankAgreementID].associableAgreements.some(
            (itm) => automaticEditFund[0].uniqueKey === itm
          )
        : false;
    const { accountNumber, bankAgreementID, registrationLines } = bank;
    const bankText = `${this.bankName(bank)} ${this.bankAccountType(
      bank,
      'DASH'
    )} ${this.bankAccountNumber(bank)}`;
    return (
      <div
        id={`bank-select-${bankAgreementID}`}
        className={`bank-select ${className} `}
      >
        <label>
          {numberOfBanks && numberOfBanks > 1 && (
            <RadioButton
              ariaLabel={`Choose bank ${bankText.replace(/\*/g, '')}`}
              className={`e2e-bank-select-${kebabCase(bankText)}`}
              onClick={() => onBankClick(bank)}
              checked={
                selectedBank && bankAgreementID === selectedBank.bankAgreementID
              }
              tabIndex={'0'}
              id={`bank-select-${bankIndex}`}
              category={'bankSelection'}
              value={bankAgreementID}
              disabled={this.isDisabled(bank)}
              labelText={''}
            />
          )}
          {/*
            All below should be updated to used agreement ID instead of account number
            we cannot rely on obfuscated acct number to always be unique.
          */}
          <div
            title={bankText}
            className={`bank-select-bank-label ${
              numberOfBanks === 1 ? 'bank-select-single-bank' : ''
            } e2e-bank-select-bank-name e2e-bank-name-${kebabCase(bankText)}`}
            disabled={this.isDisabled(bank)}
          >
            <div className="bank-select-bank-name">{this.bankName(bank)}</div>
            <div className="bank-select-bank-account">
              {`${this.bankAccountType(bank, 'DASH')} `}
              <span className="blocked_data">
                {this.bankAccountNumber(bank)}
              </span>
            </div>
          </div>
          <If test={hasValue(registrationLines)}>
            <div className="bank-select-owner-names e2e-bank-select-owner-names">
              <span className="blocked_data text-nowrap">
                {registrationLines && registrationLines.join(', ')}
              </span>
            </div>
          </If>
        </label>
        <BankStatus
          bankStatus={bank.bankStatus}
          bankNotAssociableEdit={bankNotAssociableEdit}
          bankNotAssociatedEdit={bankNotAssociatedEdit}
          accountNumber={accountNumber}
          bank={bank}
        />
      </div>
    );
  }
}

export default BankSelect;
